import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/components/ui/toast'
import api from '@/lib/api'
import { FileSpreadsheet } from 'lucide-react'
import { useEffect, useState } from 'react'
import { periodoInicial, periodoValido } from './nfPeriodo'

/**
 * Relatório Caixa: exporta em .xls, linha a linha, os serviços vigentes das NFs
 * emitidas no período — para o controle mensal do caixa na planilha.
 * Ver docs/NF.md.
 */
export default function CaixaModal({ open, onClose }) {
  const toast = useToast()
  const [periodo, setPeriodo] = useState(periodoInicial())
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) setPeriodo(periodoInicial())
  }, [open])

  async function exportar() {
    if (!periodoValido(periodo)) {
      toast.error('Informe um período válido.')
      return
    }
    setLoading(true)
    try {
      // Download por blob: a requisição precisa do JWT (interceptor do axios).
      const { data } = await api.get('/nfs/relatorio/caixa', { params: periodo, responseType: 'blob' })
      const url = URL.createObjectURL(data)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = `Caixa-${periodo.inicio}-a-${periodo.fim}.xls`
      anchor.click()
      URL.revokeObjectURL(url)
      toast.success('Planilha do caixa gerada com sucesso.')
      onClose()
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Não foi possível gerar a planilha do caixa.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Relatório Caixa"
      description="Exporta em .xls os serviços faturados das NFs emitidas no período, uma linha por serviço, ordenados por município."
      size="md"
      footer={
        <>
          <Button variant="outline" onClick={onClose}>Fechar</Button>
          <Button onClick={exportar} disabled={loading}>
            <FileSpreadsheet className="h-4 w-4" />
            {loading ? 'Gerando...' : 'Exportar planilha'}
          </Button>
        </>
      }
    >
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Data inicial</Label>
          <Input type="date" value={periodo.inicio} onChange={(e) => setPeriodo((p) => ({ ...p, inicio: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label>Data final</Label>
          <Input type="date" value={periodo.fim} onChange={(e) => setPeriodo((p) => ({ ...p, fim: e.target.value }))} />
        </div>
      </div>
    </Dialog>
  )
}
